module.exports = __webpack_public_path__ + "img/logo_large.ed5ef22a.png";